import { all, fork } from 'redux-saga/effects';
import { watchAuth } from './authSaga';
import { watchAnalytics } from './analyticsSaga';
import { watchAssessments } from './assessmentsSaga';
import { watchFeedback } from './feedbackSaga';
import { watchLogs } from './logsSaga';
import { watchNotifications } from './notificationsSaga';
import { watchPrompts } from './promptsSaga';
import { watchUsers } from './userSaga';
import { watchRole } from './roleSaga';
import { watchDashboard } from './dashboardSaga';
import { watchEmail } from './emailSaga';
import { watchSupportTickets } from './supportTicketSaga';
import { watchLeaders } from './leadersSaga';
import { watchPersonalityArchetypes } from './personalityArchetypesSaga';

export default function* rootSaga() {
    yield all([
        fork(watchAuth),
        fork(watchAnalytics),
        fork(watchAssessments),
        fork(watchFeedback),
        fork(watchLogs),
        fork(watchNotifications),
        fork(watchPrompts),
        fork(watchUsers),
        fork(watchRole),
        fork(watchDashboard),
        fork(watchEmail),
        fork(watchSupportTickets),
        fork(watchLeaders),
        fork(watchPersonalityArchetypes)
    ]);
}